import { Link } from 'react-router-dom';
import { servicesMenuColumns } from '../config/servicesMenuConfig';
import { useRegion } from '../context/RegionContext';
import './ServicesMegaMenu.css';

const ServicesMegaMenu = ({ open }) => {
  const { region } = useRegion();

  if (!open) return null;

  // Show an item if it has no region, or it matches the active region.
  const visible = (it) => !it.region || it.region === region;

  return (
    <div className="services-mega-menu" role="navigation" aria-label="Services menu">
      <div className="services-mega-inner">
        <div className="services-mega-grid">
          {servicesMenuColumns.map((column, ci) => (
            <div key={ci} className="services-mega-column">
              {column.map((grp) => {
                const items = grp.items.filter((it) => visible(it) && !it.hidden);
                if (items.length === 0) return null;
                return (
                  <div key={grp.title} className="services-mega-group">
                    <Link to={grp.overview || items[0].href} className="services-mega-heading">
                      {grp.title}
                    </Link>
                    <ul className="services-mega-list">
                      {items.map((it) => (
                        <li key={it.slug}>
                          <Link to={it.href} className="services-mega-link">
                            {it.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className="services-mega-footer">
          <Link to="/services" className="services-mega-view-all">
            View all services →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesMegaMenu;
